import classNames from 'classnames'
import './index.scss'

const Spinner = ({classname}) => {
    return (
        <span className={classNames('logout-spinner', {
            [classname]: classname
        })}/>
    )
}

export default Spinner
